/**
 * TAMIX SAAS PLATFORM - Top Navigation Bar
 * ========================================
 * Generated: 2025-09-22 - Session 6 Sprint 0
 * User profile, notifications, logout
 */

import React from 'react'
import { useAuthStore } from '@/store/authStore'

const Navbar: React.FC = () => {
  const { user, logout } = useAuthStore()

  const handleLogout = () => {
    logout()
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom px-3">
      <div className="container-fluid">
        {/* Page Title (will be updated by individual pages) */}
        <h5 className="navbar-brand mb-0 fw-normal">Dashboard</h5>

        {/* Right Side - User Menu */}
        <div className="navbar-nav ms-auto">
          <div className="nav-item dropdown">
            <button
              className="btn btn-link nav-link dropdown-toggle d-flex align-items-center"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {user?.picture ? (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="rounded-circle me-2"
                  width="32"
                  height="32"
                />
              ) : (
                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2" 
                     style={{ width: '32px', height: '32px', fontSize: '14px' }}>
                  {user?.name?.charAt(0).toUpperCase() || 'U'}
                </div>
              )}
              <span className="d-none d-md-inline">{user?.name}</span>
            </button>
            
            <ul className="dropdown-menu dropdown-menu-end">
              {/* User Info */}
              <li className="dropdown-header">
                <div className="fw-semibold">{user?.name}</div>
                <div className="text-muted small">{user?.email}</div>
                {user?.tenant && (
                  <div className="text-muted small">
                    <i className="fas fa-building me-1"></i>
                    {user.tenant.name}
                  </div>
                )}
              </li>
              
              <li><hr className="dropdown-divider" /></li>
              
              {/* User Role */}
              <li className="dropdown-item-text">
                <span className="badge bg-secondary">{user?.role}</span>
              </li>
              
              <li><hr className="dropdown-divider" /></li>
              
              {/* Menu Items */}
              <li>
                <button className="dropdown-item" type="button">
                  <i className="fas fa-user me-2"></i>
                  Mi Perfil
                </button>
              </li>
              
              <li>
                <button className="dropdown-item" type="button">
                  <i className="fas fa-cog me-2"></i>
                  Configuración
                </button>
              </li>
              
              <li><hr className="dropdown-divider" /></li>
              
              {/* Logout */}
              <li>
                <button 
                  className="dropdown-item text-danger"
                  type="button"
                  onClick={handleLogout}
                >
                  <i className="fas fa-sign-out-alt me-2"></i>
                  Cerrar Sesión
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar